<div class="locationMain">
    <a [routerLink]="['/' + languageCode, 'content', title]" [queryParams]="{ dt: 1 }">
        <img src="{{localImageLocation}}Arrows_12x16_CCC.png" alt="{{text}}"/>
    </a>
    <div class="location">
        <a [routerLink]="['/' + languageCode, 'content', title]" [queryParams]="{ dt: 1 }" class="locationLink">{{text}}</a>
    </div>
</div>
